import PropTypes from 'prop-types';
import React from 'react';
import { Quote } from '../../../quotes/quote';
import QuoteAcceptanceInformation from './quoteAcceptanceInformation';
import QuoteView from '../../../quotes/view/quoteView';
import { Modal } from '@ami/react/core';
import QuoteAcceptanceInformationFormComponent from './QuoteAcceptanceInformationFormComponent';
import { makeValidable } from '@ami/react/core';
import { monitorChangesOn } from '@ami/react/core';

const ValidableQuoteAcceptanceInformationFormComponent = makeValidable(
  monitorChangesOn(QuoteAcceptanceInformationFormComponent)
);

class QuoteAcceptanceInformationModalComponent extends React.Component {
  constructor(props) {
    super(props);
    this.validableRef = React.createRef();
    this.state = {
      showValidations: false,
      submitting: false,
      quoteAcceptanceInformation: props.isEditMode
        ? new QuoteAcceptanceInformation(props.quote.acceptance)
        : new QuoteAcceptanceInformation(),
    };
  }

  static propTypes = {
    quote: PropTypes.instanceOf(QuoteView).isRequired,
    refreshQuote: PropTypes.func.isRequired,
    showModal: PropTypes.bool.isRequired,
    hideModal: PropTypes.func,
    isEditMode: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    hideModal: () => null,
  };

  static UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      quoteAcceptanceInformation: new QuoteAcceptanceInformation(
        nextProps.quote.acceptance
      ),
    });
  }

  saveFunction() {
    return this.props.isEditMode ? Quote.updateAcceptance : Quote.accept;
  }

  handleOnSubmit = () => {
    this.setState({ showValidations: true }, () => {
      if (this.validableRef.current.isValid()) {
        this.setState({ submitting: true });
        const saveFunction = this.saveFunction();
        saveFunction(this.props.quote.id, this.state.quoteAcceptanceInformation)
          .then(() => {
            this.props.refreshQuote();
            this.props.hideModal();
          })
          .finally(() => this.setState({ submitting: false }));
      }
    });
  };

  hide = () => {
    this.setState({
      quoteAcceptanceInformation: new QuoteAcceptanceInformation(
        this.props.quote.acceptance
      ),
    });
    this.props.hideModal();
  };

  render() {
    return (
      <Modal
        title={
          this.props.isEditMode
            ? 'Edit Purchase Order Information'
            : 'Submit Purchase Order'
        }
        show={this.props.showModal}
        showCancel={true}
        onOk={this.handleOnSubmit}
        okTitle={this.props.isEditMode ? 'Update' : 'Submit'}
        onCancel={this.hide}
        onShowUpdated={(showModal) => {
          if (!showModal) this.hide();
        }}
        submitting={this.state.submitting}
        closeOnOk={false}
      >
        <ValidableQuoteAcceptanceInformationFormComponent
          areThereAnyChanges={this.props.showModal}
          ref={this.validableRef}
          showValidations={this.state.showValidations}
          quoteId={this.props.quote.id}
          quoteAcceptanceInformation={this.state.quoteAcceptanceInformation}
          onQuoteAcceptanceInformationUpdated={(quoteAcceptanceInformation) =>
            this.setState({ quoteAcceptanceInformation })
          }
        />
      </Modal>
    );
  }
}

export default QuoteAcceptanceInformationModalComponent;
